<template>
  <div class="aboutApp">
    <h1>Wanna know more about me ?</h1>
    <section>
      <h2>This is me in my holidays in the Phillipine</h2>
      <p class="blabla">I could say a lot of things about the Phillipine. I went for 2 weeks, it was amazing. I saw some of the best landscape
      on earth. The food was also great and the people were really nice. I ate so much spices, i'm now immune to it LMAO. Anyway,
        I also went to Thailand (yes i know i'm really lucky), and it was AWESOME ! I loved the temple right at the centre of the city
      of Bangkok !</p>
    </section>
    <CarouselComponent></CarouselComponent>
  </div>
</template>

<script>
import CarouselComponent from "@/components/CarouselComponent";
export default {
  name: "AboutComponent",
  components: {CarouselComponent}
}
</script>

<style scoped>
*{background-color: black;}
.aboutApp{
  background-color: black;
}
h1{
  color: darkgoldenrod;
}
h2{
  color: wheat
}
p{
  color: wheat;
}
img{
  width: 15%;
  float: left;
  display: flex;
}
section{
  background-color: black;
}
section p {
  margin-left: 20%;
  margin-right: 20%;
}

</style>